export enum AnswerType {
  Answer = 'Answer',
  Outcome = 'Outcome',
}

export interface IUiCriteriaAnswer {
  answerId: number;
  text: string;
  type: string; // AnswerType
}

export interface IUiCriteriaQuestion {
  questionId?: number;
  question: string;
  answerId?: number;
  answers: IUiCriteriaAnswer[];
  skipList: string[];
}

export interface IUiCriteria {
  questions: IUiCriteriaQuestion[];
}
